import AjaxUtil from '../../../../axios/axios';

/**
 * Fetch citation styles metadata from the backend, optionally filtered by search.
 */
export const getCitationStyles = async (searchQuery = '') => {
  try {
    return await AjaxUtil.sendRequest(
      `citation/get/citationstyles?search=${searchQuery}`,
      {},
      false,
      { 
        method: 'get', 
        showError: true, 
        isDocument: true,
      }
    );
  } catch (error) {
    throw error;
  }
};

/**
 * Fetch the CSL XML file for a specific style from the backend.
 */
export const getCitationStyleXML = async (styleId) => {
  try {
    return await AjaxUtil.sendRequest(
      `content/csl/${styleId}.csl`,
      {},
      false,
      { method: 'get', showError: true, isDocument : true }
    );
  } catch (error) {
    throw error;
  }
};
